const MOBILE_BREAKPOINT = 768;
const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

export function useIsMobile() {
  return !!isMobile;
}
